// extracted by mini-css-extract-plugin
export default {"button":"Submitbutton_button__wLv82"};